/**
 * @file Legend.js
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

class Legend extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }
  /**
   * Get legend
   *
   * @async
   * @function getLegend
   * @param {Number} legendId - Legend Id
   * @return {Promise<json>} The json with the layer style
   */
  async getLegend (legendId) {
    return new Promise((resolve, reject) => {
      if (typeof legendId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      const endPoint = `/api/0.1-a/legend/${legendId}`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get Legend From Layer
   *
   * @async
   * @function getStyle
   * @param {string} layer - Layer Uid
   * @param {string} styleType - Style type
   * @return {Promise<json>} The json with the layer style
   */
  async getFromLayer (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layerId'))
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      const endPoint = `/api/0.1-a/legend/layer/${layerId}`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get Config
   *
   * @async
   * @function getConfig
   * @param {string} layer - Layer Uid
   * @param {string} styleType - Style type
   * @return {Promise<json>} The json with the layer style
   */
  async getConfig (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layerId'))
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      const endPoint = `/api/0.1-a/legend/layer/${layerId}/config`
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
     * Create legend
     *
     * @async
     * @function create
     * @param {object} model - Model of the metadata
     * @return {Promise<json>} The json with expression created
     */
  async create (model) {
    return new Promise((resolve, reject) => {
      if (typeof model === 'undefined') reject(new Error('Esperado o model da legenda'))
      const endPoint = `/api/0.1-a/legend`
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      request.post(endPoint, model, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
  /**
   * Update legend
   *
   * @async
   * @function update
   * @param {Number} legendId - Legend Id
   * @param {object} model - Model of the metadata
   * @return {Promise<json>} The json with expression updated
   */
  async update (legendId, model) {
    return new Promise((resolve, reject) => {
      if (typeof model === 'undefined') reject(new Error('Esperado o modelo da expressão'))
      const endPoint = `/api/0.1-a/legend/${legendId}`
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      request.put(endPoint, model, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
  /**
   * Delete legend
   *
   * @async
   * @function delete
   * @param {Number} legendId - Legend Id
   * @return {Promise<string>} The data from the URL.
   */
  async delete (legendId) {
    return new Promise((resolve, reject) => {
      if (typeof legendId === 'undefined') reject(new Error('Esperado o identificador da legenda'))
      const endPoint = `/api/0.1-a/legend/${legendId}`
      const request = new Request({tag: 'das'})
      // const request = new Request({environment: 'local', tag: 'das'})
      request.delete(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
}
export { Legend }
